var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 28,
    viewBox: "0 0 311 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88 2.94387C1.32 4.23987 0.48 6.08787 0.36 8.48787H5.292C5.388 7.55187 5.736 6.78387 6.336 6.18387C6.96 5.55987 7.836 5.24787 8.964 5.24787C10.116 5.24787 10.992 5.53587 11.592 6.11187C12.216 6.68787 12.528 7.49187 12.528 8.52387C12.528 10.8039 10.824 11.9439 7.416 11.9439H6.372V16.0839H7.416C9.336 16.0839 10.752 16.3959 11.664 17.0199C12.576 17.6439 13.032 18.6759 13.032 20.1159C13.032 21.1959 12.696 22.0839 12.024 22.7799C11.376 23.4519 10.44 23.7879 9.216 23.7879C7.896 23.7879 6.852 23.4399 6.084 22.7439C5.34 22.0239 4.944 21.0759 4.896 19.8999H0C0.096 22.5639 0.996 24.5799 2.7 25.9479C4.404 27.3159 6.612 27.9999 9.324 27.9999C10.2949 27.9999 11.189 27.9091 12.0063 27.7275H309.5C310.328 27.7275 311 27.056 311 26.2275C311 25.3991 310.328 24.7275 309.5 24.7275H16.6462C16.7166 24.6207 16.7839 24.5114 16.848 24.3999C17.52 23.2719 17.856 21.9879 17.856 20.5479C17.856 18.8199 17.46 17.4039 16.668 16.2999C15.9 15.1959 14.82 14.4279 13.428 13.9959V13.8519C14.508 13.4919 15.432 12.7959 16.2 11.7639C16.992 10.7079 17.388 9.42387 17.388 7.91187C17.388 6.59187 17.064 5.41587 16.416 4.38387C15.792 3.32787 14.856 2.49987 13.608 1.89987C12.36 1.27587 10.86 0.963867 9.108 0.963867C6.54 0.963867 4.464 1.62387 2.88 2.94387Z",
    fill: "url(#paint0_linear_189_24893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_24893",
    x1: -1.06092,
    y1: -44.8745,
    x2: 451.357,
    y2: 41.8766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5249AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362999,
    stopColor: "#FC7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6407,
    stopColor: "#C7BEFC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957743,
    stopColor: "#FCC5BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/Three.bb9860a0e422021db939096184cb4a3e.svg";
export { ForwardRef as ReactComponent };